/// <reference path="../typings/index.d.ts" />
/// <reference path="LaddaButtonLoading.d.ts" />
declare var Ladda: any;
namespace App {
    export class LaddaButtonLoading implements ILaddaButtonLoading {
        private button: JQuery;
        private buttonLadda: any;
        private textoCorrente: string = null;

        public inicializarCampo(seletor: string): void {
            this.button = $(seletor);
            return this.buttonLadda = Ladda.create(document.querySelector(seletor));
        }

        public exibirLoading(textoLoading: string = null): void {
            this.buttonLadda.start();
            if (textoLoading) {
                this.textoCorrente = this.button.find('.text-button-ladda').text();
                this.button.find('.text-button-ladda').text(textoLoading);
            } else if (this.button.data("textoLoading")) {
                this.textoCorrente = this.button.find('.text-button-ladda').text();
                this.button.find('.text-button-ladda').text(this.button.data("textoLoading"));
            }
        }

        public ocultarLoading(textoAposLoading: string = null): void {
            if (textoAposLoading) {
                this.button.find('.text-button-ladda').text(textoAposLoading);
            } else if (this.button.data("textoOriginal")) {
                this.button.find('.text-button-ladda').text(this.button.data("textoOriginal"));
            } else if (this.textoCorrente) {
                this.button.find('.text-button-ladda').text(this.textoCorrente);
            }
            this.buttonLadda.stop();
        }

    }
}
